(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.directive('emailFileList', [EmailFileListFn]);

    /* email file list directive */
    function EmailFileListFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/email/overview/templates/email-file-list.template.html',
            scope: {
                files: '='
            }
        };
        return directive;
    }
})();